import { normalizeFilestorePath } from "@entities/document";

export function resolveFilestoreDocumentUrl(
  originalData?: Record<string, unknown> | null,
): string | undefined {
  if (!originalData) {
    return undefined;
  }

  const documentUrl = originalData.documentUrl as string | undefined;
  if (documentUrl) {
    return normalizeFilestorePath(documentUrl);
  }

  const linkToPdf = originalData.linkToPdf as string | undefined;
  if (!linkToPdf) {
    return undefined;
  }

  return normalizeFilestorePath(linkToPdf);
}
